var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01aa6d",
    fillOpacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.448287, 345.595075)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 113.699219 -144.539062 C 113.699219 -130.554688 104.445312 -120.070312 90.257812 -120.070312 L 69.492188 -120.070312 L 69.492188 -234.589844 L 90.054688 -234.589844 C 104.238281 -234.589844 113.699219 -224.515625 113.699219 -209.714844 Z M 14.804688 -7.8125 C 14.804688 -2.878906 17.066406 0 21.792969 0 L 62.707031 0 C 67.4375 0 69.492188 -2.878906 69.492188 -7.8125 L 69.492188 -70.519531 L 94.371094 -70.519531 C 136.722656 -70.519531 168.59375 -103.621094 168.59375 -144.949219 L 168.59375 -210.742188 C 168.59375 -252.066406 136.722656 -284.550781 94.371094 -284.550781 L 21.792969 -284.550781 C 17.476562 -284.550781 14.804688 -281.46875 14.804688 -276.535156 Z M 14.804688 -7.8125 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#01aa6d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.839149, 326.98593)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 113.699219 -144.539062 C 113.699219 -130.554688 104.445312 -120.070312 90.257812 -120.070312 L 69.492188 -120.070312 L 69.492188 -234.589844 L 90.054688 -234.589844 C 104.238281 -234.589844 113.699219 -224.515625 113.699219 -209.714844 Z M 14.804688 -7.8125 C 14.804688 -2.878906 17.066406 0 21.792969 0 L 62.707031 0 C 67.4375 0 69.492188 -2.878906 69.492188 -7.8125 L 69.492188 -70.519531 L 94.371094 -70.519531 C 136.722656 -70.519531 168.59375 -103.621094 168.59375 -144.949219 L 168.59375 -210.742188 C 168.59375 -252.066406 136.722656 -284.550781 94.371094 -284.550781 L 21.792969 -284.550781 C 17.476562 -284.550781 14.804688 -281.46875 14.804688 -276.535156 Z M 14.804688 -7.8125 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.ce3f4e25c36860d14b9e147a4cf7ff26.svg";
export { ForwardRef as ReactComponent };